module.exports = __webpack_public_path__ + "media/images/metronic/social/skype-b339858b56d4761c57e1a5f9180ba8e1.png";